/****************************************************************************
 Copyright (c) 2017 Chukong Technologies Inc.

 http://www.cocos.com

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated engine source code (the "Software"), a limited,
  worldwide, royalty-free, non-assignable, revocable and  non-exclusive license
 to use Cocos Creator solely to develop games on your target platforms. You shall
  not use Cocos Creator software for developing other software or tools that's
  used for developing games. You are not granted to publish, distribute,
  sublicense, and/or sell copies of Cocos Creator.

 The software or tools in this License Agreement are licensed, not sold.
 Chukong Aipu reserves all rights not expressly granted to you.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 ****************************************************************************/

// TODO: 文本类文件缓存
// TODO: 后续流程失败时删除本地文件

import LFUCache from './LFUCache'

var ID = 'WXDownloader'

var ZIP_ENABLE = window.mini && mini.supportUnzip();
var cache_format = [
    '.png',
    '.jpg',
    '.plist',
    '.json',
    '.pack',
    '.strings',
    '.fnt',
    '.pvr',
    '.ttf',
    '.mp3'
]

const REGEX = /^\w+:\/\/.*/
const IMAGE_REGEX = /\.(png|jpg|jpeg)$/

function isImage(url) {
    // 微信头像可能没有.文件后缀
    return IMAGE_REGEX.test(url) || (mini.getPlatform() === MiniPlatform.wechatGame && /^https:\/\/(wx|thirdwx)\.qlogo\.cn\//.test(url))
}
let _tmpCacheMap = {}    // 临时文件映射表
let _tmpLocalBrokenFiles = {}   // 本地破损文件

var fs = mini.getFileSystemManager()

var WX_CACHE_MAX_CAPACITY = 50 * 1024 * 1024
if (window.mini && mini.getPlatform() === MiniPlatform.wechatGame) {
    // if (__DEBUG){
    //     console.log("LFU WX_CACHE_MAX_CAPACITY=10M")
    //     WX_CACHE_MAX_CAPACITY = 10 * 1024 * 1024
    // }else{
        console.log("LFU WX_CACHE_MAX_CAPACITY=180M")
        WX_CACHE_MAX_CAPACITY = 180 * 1024 * 1024
    // }
}

var WXDownloader = (window.WXDownloader = function() {
    this.id = ID
    this.async = true
    this.pipeline = null
    this.REMOTE_SERVER_ROOT = ''
})
WXDownloader.ID = ID

WXDownloader.prototype.handle = function(item, callback) {
    // 跳过js脚本
    // 文本不能直接通过 wxfile:// 获取，暂不支持，跳过文本格式
    // mp3会有延迟，暂不支持
    // console.log("wx-downloader handle item.type="+item.type)
    if (!item.type || cache_format.indexOf(item.type) < 0) {
        callback(null, item)
        return
    }
    var filePath = item.url

    // 如果是一个破损文件，跳过当前步骤
    if (_tmpLocalBrokenFiles[filePath]) {
        delete _tmpLocalBrokenFiles[filePath];
        readFromLocal(item, callback);
        return;
    }
    
    // Read from package
    fs.access({
        path: filePath,
        success: function() {
            item.realUrl = filePath;
            callback(null, item)
        },
        fail: function(res) {
            readFromLocal(item, callback)
        }
    })
}

function removeDir (dirPath) {
    if (dirPath !== mini.env.USER_DATA_PATH) {
        fs.rmdirSync(mini.env.USER_DATA_PATH, true);
    } else {
        // 根目录wx Android无法直接删除，需要递归处理
        let paths = fs.readdirSync(dirPath)
        for (var i = 0; i < paths.length; i++) {
            var path = dirPath + '/' + paths[i]
            var fileStat = fs.statSync(path)
            if (fileStat.isDirectory()) {
                fs.rmdirSync(path, true);
            } else {
                fs.unlinkSync(path);
            }
        } 
    }
}

WXDownloader.prototype.getUserDataPath = function(path) {
    return mini.env.USER_DATA_PATH + '/' + path
}

WXDownloader.prototype.cleanAllAssets = function(cache, cacheLength, savedFileLength) {
    try {
        removeDir(mini.env.USER_DATA_PATH);
        cache.clear()
        console.log('cleancache 清理文件缓存成功', cacheLength, savedFileLength)

        window.logCenter && logCenter.error(new Error(` wx-downloader cleanAllAssets cacheLength:${cacheLength} savedFileLength:${savedFileLength}`), 'FileCacheClear');
        // Toast.make("清理文件缓存成功")
        // window.mini && mini.showToast({
        //     title: '清理文件缓存成功'
        //   })
    } catch (e) {
        console.error("cleancache 清理文件缓存异常 wx-downloader cleanAllAssets failed.", cacheLength, savedFileLength, e);
        
        window.logCenter && window.logCenter.error("wx-downloader cleanAllAssets failed.", 'wx-downloader', 0, 0, e);
    }
}

WXDownloader.prototype.removeAssets = function (assetPaths) {
    for (var i = 0; i < assetPaths.length; i++) {
        // cache remove 时会调用onRemove删除
        let path = assetPaths[i]
        if (cache.has(path)) {
            cache.remove(assetPaths[i])
        } else {
            path = this.getUserDataPath(path)
            fs.unlinkSync(path)
        }
    }
    cache.saveToStorage()
    //cache.saveToStorageAsync().then(()=>{})
}

WXDownloader.prototype.setLFUCache = function (capacity, washoutTriggerRatio, washoutTargetRatio){
    cache.capacity = capacity
    cache.washoutTriggerRatio = washoutTriggerRatio
    cache.washoutTargetRatio = washoutTargetRatio
}

function readDir (dirPath) {
    var results = []
    var paths = fs.readdirSync(dirPath)
    for (var i = 0; i < paths.length; i++) {
        var path = dirPath + '/' + paths[i]
        var fileStat = fs.statSync(path)
        if (fileStat.isDirectory()) {
            results = results.concat(readDir(path))
        } else {
            results.push(path.replace(mini.env.USER_DATA_PATH + '/', ''))
        }
    }
    return results
}

// function walkFiles(dir, action, done) {

//     // this flag will indicate if an error occured (in this case we don't want to go on walking the tree)
//     var dead = false;

//     // this flag will store the number of pending async operations
//     var pending = 0;

//     var fail = function(err) {
//         if(!dead) {
//             dead = true;
//             done(err);
//         }
//     };

//     var checkSuccess = function() {
//         if(!dead && pending == 0) {
//             done();
//         }
//     };

//     var performAction = function(file, stat) {
//         if(!dead) {
//             try {
//                 action(file, stat);
//             }
//             catch(error) {
//                 fail(error);
//             }
//         }
//     };

//     // this function will recursively explore one directory in the context defined by the variables above
//     var dive = function(dir) {
//         pending++; // async operation starting after this line
//         fs.readdir({
//             dirPath: dir,
//             success: function(res) {
//                 if (!dead) {
//                     let list = res.files
//                     list.forEach(function(file) {
//                         if(!dead) { // if we are already dead, we don't do anything
//                             var pathName = dir + '/' + file
//                             pending++; // async operation starting after this line
//                             fs.stat({
//                                 path: pathName,
//                                 success: function(res) {
//                                     if (!dead) {
//                                         let stat = res.stats
//                                         if (stat && stat.isDirectory()) {
//                                             dive(pathName); // it's a directory, let's explore recursively
//                                         } else {
//                                             performAction(pathName, stat); // it's not a directory, just perform the action
//                                         }
//                                         pending--; checkSuccess(); // async operation complete
//                                     }
//                                 },
//                                 fail: function(error) {
//                                     fail(error)
//                                 }
//                             })
//                         }
//                     })
//                     pending--; checkSuccess(); // async operation complete
//                 }
//             },
//             fail: function(error) {
//                 fail(error)
//             }
//         })
//     };

//     // start exploration
//     dive(dir)
// };

// function getFilesRecursively(root, callback) {
//     curFiles = []

//     walkFiles(root, function(file, stat) {
//         var relPath = file.split(root + '/')[1]
//         curFiles.push(relPath)
//     }, function() {
//         callback(curFiles)
//     })
// }


WXDownloader.prototype.getSavedFileList = function () {
    return readDir(mini.env.USER_DATA_PATH)
}

// 清理缓存间隔时间，30分钟内只触发一次
const SYNC_LIMIT_MILSEC = 30 * 60 * 1000;
// 是否清理中标识
let _isSynceBusy = false
// 上一次清理时间
let _lastSynceTime = 0
function syncCache() {
    // qq dev工具有bug，跳过
    if (mini.getPlatform() === MiniPlatform.qqlightGame && mini.isDevTool())
        return;

    // TODO: vivo没有同步读取，暂时关闭
    if (mini.getPlatform() === MiniPlatform.oppoQuickgame || mini.getPlatform() === MiniPlatform.vivo)
        return;
    if (_isSynceBusy)
        return;
        
    if (Date.now() - _lastSynceTime <= SYNC_LIMIT_MILSEC)
        return;

    _isSynceBusy = true;
    try {
        _syncCache()
    } catch (e) {
        console.error("_syncCache failed", e);
        window.logCenter && window.logCenter.error(e.message, 'syncCache', 0, 0, e);
    }
    _lastSynceTime = Date.now()
    _isSynceBusy =  false;
}

function _syncCache() {
    let startTime = Date.now()
    console.info('sync cache')
    let md5FlatMap = ResManager.getFlatMd5Map()
    console.info('sync cache 1', Date.now() - startTime)
    let cacheMap = wxCache.keyMap
    // 微信读取文件列表神TM耗时
    let localFileList = wxDownloader.getSavedFileList()
    console.info('sync cache 2', Date.now() - startTime)
    let unusedFileList = []
    let unrecordedFileList = []
    for (let i = 0; i < localFileList.length; i++) {
        let file = localFileList[i]
        if (!md5FlatMap[file]) {
            unusedFileList.push(file)
        } else if (!cacheMap[file]) {
            unrecordedFileList.push(file)
        }
    }
    console.info('sync cache 3', Date.now() - startTime)
    if (unusedFileList.length) {
        console.info('remove unused file cache', unusedFileList)
        wxDownloader.removeAssets(unusedFileList.concat(unrecordedFileList))
    }
    // console.info('sync cache 4', Date.now() - startTime)
    // if (unrecordedFileList.length) {
    //     console.info('add unrecord file to cache', unrecordedFileList)
    //     /*let index = 0;
    //     for (; index < unrecordedFileList.length;){
    //         let path = wxDownloader.getUserDataPath(unrecordedFileList[index])
    //         let fileInfo = fs.statSync(path)
    //         wxCache.setAsync(file, path, fileInfo.size).then(()=>{index+=1}).catch(()=>{index+=1})
    //     }*/
    //     unrecordedFileList.forEach(file => {
    //         let path = wxDownloader.getUserDataPath(file)
    //         let fileInfo = fs.statSync(path)
    //         wxCache.set(file, path, fileInfo.size)
    //     })
    // }
    console.info('sync cache done', Date.now() - startTime)
}

var wxDownloader = (window.wxDownloader = new WXDownloader())

var cache = (window.wxCache = new LFUCache(WX_CACHE_MAX_CAPACITY, {
    onRemove: function(key, value) {
        try {
            fs.unlinkSync(value.value)
            cc.log('Cache onRemove, removed local file ' + value.value + ' successfully!')
        } catch (e) {
            cc.error('Removed local file ' + value.value + ' failed!')
        }
    }
})).readFromStorage(WX_CACHE_MAX_CAPACITY)

var downloadTask = null;
if (cc.sys.useDownloadTask){
    var DownloadTask = require('./downloadTask')
   downloadTask = new DownloadTask(downloadRemoteFile)
}

function nextPipe(item, callback) {
    var queue = cc.LoadingItems.getQueue(item)
    queue.addListener(item.id, function(item) {
        if (item.error) {
            fs.unlink({
                filePath: item.url,
                success: function() {
                    cc.log('Load failed, removed local file ' + item.url + ' successfully!')
                }
            })
        }
    })
    callback(null, null)
}

function readText(item, callback) {
    var url = item.url
    fs.readFile({
        filePath: url,
        encoding: 'utf8',
        success: function(res) {
            item.states[cc.loader.downloader.id] = cc.Pipeline.ItemState.COMPLETE
            callback(null, res.data)
        },
        fail: function(res) {
            cc.warn('Read file failed: ' + url)
            fs.unlink({
                filePath: url,
                success: function() {
                    cc.log('Read file failed, removed local file ' + url + ' successfully!')
                }
            })
            callback({
                status: 0,
                errorMessage: res && res.errMsg ? res.errMsg : 'Read text file failed: ' + url
            })
        }
    })
}

function readFromLocal(item, callback) {
    var localPath = (REGEX.test(item.url) && IMAGE_REGEX.test(item.url) && _tmpCacheMap[item.url])? _tmpCacheMap[item.url]: (mini.env.USER_DATA_PATH + '/' + item.url);

    // 如果是一个破损文件，跳过当前步骤
    if (_tmpLocalBrokenFiles[localPath]) {
        delete _tmpLocalBrokenFiles[localPath];
        
        if (cc.sys.useDownloadTask){
            downloadTask.addDownFile(item, callback)
        }else{
            downloadRemoteFile(item, callback)
        }

        return;
    }


    // Read from local file cache
    fs.access({
        path: localPath,
        success: function() {
            cache.get(item.url)
            item.realUrl = localPath
            setTimeout(() => callback(null, item), 0)
        },
        fail: function(res) {
            // No remote server indicated, then continue to downloader
            // if (!wxDownloader.REMOTE_SERVER_ROOT) {
            //     callback(null, null);
            //     return;
            // }
            if (cc.sys.useDownloadTask){
                downloadTask.addDownFile(item, callback)
            }else{
                downloadRemoteFile(item, callback)
            }
        }
    })
}

function ensureDirFor(path, callback) {
    // cc.log('mkdir:' + path);
    var ensureDir = cc.path.dirname(path)
    if (ensureDir === 'wxfile://usr' || ensureDir === 'http://usr' || ensureDir === mini.env.USER_DATA_PATH) {
        callback()
        return
    }
    fs.access({
        path: ensureDir,
        success: callback,
        fail: function(res) {
            ensureDirFor(ensureDir, function() {
                fs.mkdir({
                    dirPath: ensureDir,
                    complete: callback
                })
            })
        }
    })
}

function downloadRemoteFile(item, callback) {
    // Download from remote server
    var relatUrl = item.url
    // filter protocol url (E.g: https:// or http:// or ftp://)
    let notInRes = false
    if (REGEX.test(relatUrl)) {
        if (isImage(relatUrl)) {
            // 远程图片资源下载到临时目录
            notInRes = true;
        } else {
            callback(null, item)
            return
        }
    }
    let zipUrl = (ZIP_ENABLE && !notInRes)? ResManager.getZip(item.url): null;
    _downloadRemoteFile(item, callback, zipUrl, notInRes);
}

function _downloadRemoteFile(item, callback, zipUrl, notInRes) {
    var remoteUrl = zipUrl? `${item.realUrl.substring(0, item.realUrl.length - item.url.length) + zipUrl}`: item.realUrl
    mini.downloadFile({
        url: remoteUrl,
        enableHttp2: typeof(_G) != "undefined" && _G.EnableHttp2,
        success: function(res) {
            if (res.statusCode === 404) {
                console.warn('Download file failed: ' + remoteUrl);

                if (zipUrl) {
                    // 下载非zip
                    _downloadRemoteFile(item, callback, null);
                } else {
                    callback({
                        status: 0,
                        errorMessage:
                            res && res.errMsg ? res.errMsg : 'Download file failed: ' + remoteUrl
                    })
                } 
            } else if (res.statusCode === 200 && res.tempFilePath) {
                if (zipUrl) {
                    mini.getFileSystemManager().unzip({
                        zipFilePath: res.tempFilePath,
                        targetPath: mini.env.USER_DATA_PATH,
                        success: ()=> {
                            onDownload(`${mini.env.USER_DATA_PATH}/${item.url}`, notInRes, item, callback);
                        },
                        fail: (err)=> {
                            console.warn('unzip failed.' + res.tempFilePath, err);
                            // 2020-4-1 有部分玩家在unzip到wx.env.USER_DATA_PATH目录下时，报错：
                            //  unzip:fail permission denied, open  wxfile://usr
                            // 其中提交客服信息的玩家手机信息为：7.0.12-2.10.3-Android10-HRY-AL00T 但是未能重现
                            // 因此解压失败以后重下unzip版
                            _downloadRemoteFile(item, callback, null);
                        }
                    })
                } else {
                    onDownload(res.tempFilePath, notInRes, item, callback);
                }               
            } else {
                callback(null, item)
            }
        },
        fail: function(res) {
            // Continue to try download with downloader, most probably will also fail
            callback(null, item)
        }
    })
}

function onDownload(downloadPath, notInRes, item, callback) {
    fs.getFileInfo({
        filePath:downloadPath,
        success: function(info) {
            if (notInRes) {
                _tmpCacheMap[item.url] = downloadPath;
                if (item.isHead == false){
                    cache.set(item.url, downloadPath, info.size)
                }
                item.realUrl = downloadPath
                callback(null, item)
                return;
            } 
            // http reading is not cached
            var localPath = mini.env.USER_DATA_PATH + '/' + item.url
            if (downloadPath === localPath) {
                if (item.isHead == false){
                    cache.set(item.url, downloadPath, info.size)
                }
                item.realUrl = downloadPath
                callback(null, item)
            } else {
                // check and mkdir remote folder has exists
                ensureDirFor(localPath, function() {
                    let onSuccess = (realUrl)=> {
                        if (item.isHead == false){
                            cache.set(item.url, realUrl, info.size)
                        }
                        item.realUrl = realUrl
                        callback(null, item)
                    }
                    let onFail = (err)=> {
                        // Failed to save file, then just use remote url
                        // 失败的话先同步一波
                        console.error(`saveFile error`, item.url, err)
                        if(window.logCenter) {
                            logCenter.warn(new Error(`wx-downloader file error url: ${item.url},error: ${err}`), "wx-download-error");
                        }
                        syncCache();
                        callback(null, item)
                    }
                    // Save to local path
                    fs.saveFile({
                        tempFilePath: downloadPath,
                        filePath: localPath,
                        success: function(res) {                            
                            if (!res || !res.savedFilePath) {
                                try{
                                    window.DCAssist && DCAssist.dc4SaveFileFailed(
                                        Object.assign(res || {}, {
                                            remoteUrl: item.realUrl,
                                            downloadUrl: downloadPath,
                                            localPath: localPath,
                                            info: 'no savedFilePath'
                                        })
                                    );
                                }catch(e) {}
                                // 如果没有saveFilePath， 再进行一次access
                                fs.access({
                                    path: localPath,
                                    success: ()=> onSuccess(localPath),
                                    fail: (err)=> onFail(err)
                                })
                            } else {
                                onSuccess(res.savedFilePath);
                            }
                        },
                        fail: (err)=> {
                            try{
                                window.DCAssist && DCAssist.dc4SaveFileFailed(
                                    Object.assign(err || {}, {
                                        remoteUrl: item.realUrl,
                                        downloadUrl: downloadPath,
                                        localPath: localPath,
                                        info: 'saveFile failed'
                                    })
                                );
                            }catch(e) {}

                            onFail(err);
                        }
                    })
                })
            }
        },
        fail: function(err) {
            console.error(`getFileInfo error`, item.url, err)
            callback(null, item)
        }
    })
}


// 在实际loader加载之前处理本地缓存
// TODO:
// 之后最好重构成 Pipeline 的形式
// 再将之前的md5流程加入
let CCLoaderLoad = cc.loader._loaderLoad

cc.loader._loaderLoad = function (loader, type, realUrl, url, item, cb) {
    var baseUrl = url
    // 获取MD5地址
    if (cc.loader.resPath) {
        baseUrl = realUrl.replace(cc.loader.resPath, '')
        if (baseUrl[0] === '/') {
            baseUrl = baseUrl.substr(1)
        }
    }

    wxDownloader.handle({
        type,
        url: baseUrl,
        realUrl,
        isHead: (item.isHead == true)
    }, function(err, res) {
        if (err) {
            cb(err);
        } else {
            CCLoaderLoad.call(cc.loader, loader, type, res.realUrl, url, item, cb)
        }
    })
}

cc.loader._pharseKTX = function (arrayBuffer) {
    try {
        let checkAry = new Uint8Array(arrayBuffer); // 只是对array做个校验，不会读取实际信息
        return Promise.resolve(arrayBuffer)
    } catch(e) {
        console.error("[wx-downloader] _pharseKTX failed!", e);
        return Promise.reject('parseKTX failed!');
    }

    /*var zip
    return Promise.resolve(arrayBuffer)
    /*var zip = new jszip();
    return zip.loadAsync(arrayBuffer).then(
      (zipfile)=>{
        let files = zipfile.files
        for (let key in files){
          console.log("@@@@key,",key)
          return zip.file(key).async("arraybuffer").then(
            (arraybuffer1)=>{
                zip.remove(key)
                return arraybuffer1
            })
        }
      }).catch(
        (err)=>{
          console.log("load zip failed ", JSON.stringify(err))
        });*/
}

// 处理本地文本读取
function isWebUrl(url) {
    return /^http(s|):\/\//.test(url) && !isDevLocal(url);
}

function isDevLocal(url) {
    if (mini.getPlatform() === MiniPlatform.wechatGame && mini.isDevTool())
        return /^http:\/\/(usr|tmp)\//.test(url);

    return false;
}
var _cc_loadTxt = cc.loader.loadTxt;
cc.loader.loadTxt = function(url, cb) {
    if (isWebUrl(url))
        return _cc_loadTxt.call(cc.loader, url, cb);
    else {
        // 按本地文件处理
        fs.readFile({
            filePath: url,
            encoding: 'utf8',
            success: res=> {
                cb(null, res.data)
            },
            fail: err=> {
                cb({
                    status: 404,
                    errorMessage: `load local Txt failed, err=${JSON.stringify(err)}`
                }, null);
            }
        });
    }
}

var _cc_loadBinary = cc.loader.loadBinary;
cc.loader.loadBinary = function(url, cb) {
    if (isWebUrl(url))
        return _cc_loadBinary.call(cc.loader, url, cb);
    else {
        // 按本地文件处理
        fs.readFile({
            filePath: url,
            success: res=> cb(null, res.data),
            fail: err=> {
                cb({
                    status: 404,
                    errorMessage: `load local Binary failed, err=${JSON.stringify(err)}`
                }, null);
            }
        });
    }
}

var _cc_loadImg = cc.loader.loadImg;
cc.loader.loadImg = function(url, option, callback, img) {
    let useOptionAsCallback = callback === undefined && option !== undefined;
    let oldCallback = useOptionAsCallback? option: callback;
    let newCallback = function(err, texture, ext) {
        if (err) {
            if (!isWebUrl(url)) {
                // 如果本地文件加载失败，当前游戏生命周期内，下一次不读取本地的
                _tmpLocalBrokenFiles[url] = true;
            }
            console.warn("[wx-downloader] cc.loader.loadImg failed.", url, err);
        }
        oldCallback && oldCallback(err, texture, ext);
    }

    if (useOptionAsCallback) {
        return _cc_loadImg.call(cc.loader, url, newCallback, callback, img);
    } else {        
        return _cc_loadImg.call(cc.loader, url, option, newCallback, img);
    }
}


var _cc_loadJson = cc.loader.loadJson;
cc.loader.loadJson = function(url, cb) {
    let oldCallback = cb;
    let newCallback = function(err, result) {
        if (err) {
            if (!isWebUrl(url)) {
                // 如果本地文件加载失败，当前游戏生命周期内，下一次不读取本地的
                _tmpLocalBrokenFiles[url] = true;
            }
            console.warn("[wx-downloader] cc.loader.loadJson failed.", url, err);
        }
        oldCallback && oldCallback(err, result);
    }
    return _cc_loadJson.call(cc.loader, url, newCallback);
}
